import { Button, type ButtonProps } from 'antd';
import type { Ref } from 'react';

export interface BaseButtonProps extends ButtonProps {
  appearance?: 'default' | 'soft' | 'content-link';
  ref?: Ref<HTMLButtonElement | HTMLAnchorElement>;
  wrap?: boolean;
}

/** 统一项目按钮入口与轻量操作外观，原生状态、事件及 ref 保持透传。 */
export default function BaseButton({
  appearance = 'default',
  className,
  autoInsertSpace = false,
  htmlType = 'button',
  wrap = false,
  ...props
}: BaseButtonProps) {
  return (
    <Button
      {...props}
      htmlType={htmlType}
      autoInsertSpace={autoInsertSpace}
      className={[
        'base-button',
        appearance === 'soft' && 'base-button--soft',
        appearance === 'content-link' && 'base-button--content-link',
        wrap && 'base-button--wrap',
        className,
      ]
        .filter(Boolean)
        .join(' ')}
    />
  );
}
